import { theme, Typography } from 'antd';

const { Text } = Typography;

export type PropertyItem = {
  key: string;
  label: string;
  value: React.ReactNode;
  isEditable?: boolean; // TBD for future inline edits
};

interface GovardPropertyListProps {
  items: PropertyItem[];
  layout?: 'horizontal' | 'vertical';
}

/**
 * GovardPropertyList renders a dense list of key-value properties.
 * Perfect for the "Dossier" sidebar of an Entity Workspace.
 */
export function GovardPropertyList({ items, layout = 'vertical' }: GovardPropertyListProps) {
  const { token } = theme.useToken();

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: token.marginMD,
      }}
    >
      {items.map((item) => (
        <div
          key={item.key}
          style={{
            display: 'flex',
            flexDirection: layout === 'horizontal' ? 'row' : 'column',
            justifyContent: layout === 'horizontal' ? 'space-between' : 'flex-start',
            alignItems: layout === 'horizontal' ? 'center' : 'flex-start',
            gap: layout === 'horizontal' ? token.marginSM : token.marginXXS,
          }}
        >
          <Text
            type="secondary"
            style={{
              fontSize: token.fontSizeSM,
              fontWeight: 500,
            }}
          >
            {item.label}
          </Text>
          <div style={{ wordBreak: 'break-word', color: token.colorText }}>
            {item.value || <Text type="secondary" italic>—</Text>}
          </div>
        </div>
      ))}
    </div>
  );
}
